export function isActionChildEvent(id) {
  return function (event) {
    return event.action !== undefined && event.action.id !== undefined && event.action.id.includes(id);
  };
}